import React from 'react'
import LabelImportantIcon from '@material-ui/icons/LabelImportant'
import invoicesStatus from '../configurations/invoices-status'
import invoicesSPStatus from '../configurations/invoices-sp-status'
import receiverTypes from '../configurations/notification-receiver-types'
import notificationTypes from '../configurations/notification-types'
import notificationChannels from '../configurations/notification-channels'
import moment from 'moment'

export const ListingHeaders = {
  /** users listing stats **/
  taxableItems: [
    { id: 'typeView', label: 'Fields.label.type' },
    { id: 'subTypeView', label: 'Fields.label.subType' },
    { id: 'rateView', label: 'Fields.label.rate' },
    { id: 'valueView', label: 'Fields.label.value' }
  ],

  packageItemCodes: [
    { id: 'codeTypeNamePrimaryLang', label: 'Fields.label.view.Code.codeType' },
    { id: 'codeLookupValue', label: 'Fields.label.view.Code.itemCode' },
    { id: 'codeNamePrimaryLang', label: 'Fields.label.view.Code.codeName_en' },
    { id: 'codeNameSecondaryLang', label: 'Fields.label.view.Code.codeName_ar' },
    { id: 'codeDescriptionPrimaryLang', label: 'Fields.label.view.Code.description_en' },
    { id: 'codeDescriptionSecondaryLang', label: 'Fields.label.view.Code.description_ar' },
    { id: 'codeCategorization', label: 'Fields.label.view.Code.category' },
    { id: 'activeFrom', label: 'Fields.label.view.Code.activeFrom' },
    { id: 'activeTo', label: 'Fields.label.view.Code.activeTo' },
    { id: 'active', label: 'Fields.label.view.Code.active' }
  ]
}

export const arrangeListingData = (entityName, data, currency, locale) => {
  if (!!data && !!data?.length) {
    switch (entityName) {
      case 'notification':
        data.forEach((item) => {
          let receiverObj = receiverTypes.filter((i) => i.name_en.toLowerCase() === item.receiverType.toLowerCase())[0]
          let receiverId = receiverObj?.id
          let receiverNotificationTypes = notificationTypes.filter((i) => i.receiver_type === receiverId?.toString())
          let isSP = !!item?.hasOwnProperty("message")
          item['typeName'] = isSP ? receiverNotificationTypes.filter((i) => i.sp_lookup === item.typeId.toString())[0][`name_${locale}`] : item.typeName
          item['channel'] = isSP ? notificationChannels.filter((i) => i.sp_id === item.channelId)[0][`name_${locale}`] : item.channel
          item['creationDateTime'] = isSP ? (!!item.receivedDatetime ? moment(item.receivedDatetime).locale('en-us').format() : null) : item.creationDateTime
          item['receivedDateTime'] = isSP ? (!!item.receivedDatetime ? moment(item.receivedDatetime).locale('en-us').format() : null) : item.receivedDateTime
          item['deliveredDateTime'] = isSP ? (!!item.deliveredDatetime ? moment(item.deliveredDatetime).locale('en-us').format() : null) : item.deliveredDateTime
          item['receiverName'] = isSP ? '' : item.receiverName
          item['receiverId'] = receiverId
          item['messageBody'] = isSP ? item.message : item.finalMessage
          item['receiverType'] = isSP ? receiverObj[`name_${locale}`] : item.receiverType
          item['deliveryType'] = isSP ? ((item.cycle !== 'immediate') ? 'batched' : 'notBatched') : ((item.isBacthed) ? 'batched' : 'notBatched')
        })
        break
      case 'codesSearch':
        data.forEach((item) => {
          if (!!item.codeLookupValue) {
            item['name'] = item.codeLookupValue
          }
        })
        break

      case 'packageItemCodes':
        data.forEach((item) => {
          if (!!Object.keys(item || {})?.length) {
            item['icon'] = <LabelImportantIcon/>
            if (!!item?.codeLookupValue) {
              item['headerTitle'] = <span>{item?.codeLookupValue} <span> ({item?.codeTypeNamePrimaryLang})</span></span>
              item['name'] = (locale === 'ar') ? item?.codeNameSecondaryLang || item?.codeNamePrimaryLang : item?.codeNamePrimaryLang
            }
          }
        })
        break
      case 'taxableItems':
        data.forEach((item) => {
          if (!!item && !!Object.keys(item || {})?.length) {
            item['icon'] = <LabelImportantIcon/>
            if (!!item?.typeName) {
              item['headerTitle'] = <span>{item?.typeName} <span> ({item.type})</span> <span
                className={'tax-header-value'}>(<strong>{item?.value} {currency}</strong>)</span></span>
              item['name'] = item.typeName
              item['typeView'] = <div>{item?.typeName} <span> ({item.type})</span></div>
              item['subTypeView'] = <div>{item?.subTypeName} <span> ({item.subType})</span></div>
              item['rateView'] = <span>{item?.rate} %</span>
              item['valueView'] = <span className={'tax-header-value'}><strong>{item?.value} {currency}</strong></span>
            }
          }
        })
        break
      default:
        break
    }
  }
  return data
}


export const arrangeSingleInvoice = (data, locale) => {
  let statusArr = data?.status && invoicesSPStatus?.length ? invoicesSPStatus.filter((item) => item.key.toString().toLowerCase() === data?.status?.toString()?.toLowerCase()) : []
  let msStatusArr = data?.MSStatus && invoicesStatus?.length ? invoicesStatus.filter((item) => item.key.toString().toLowerCase() === data?.MSStatus?.toString()?.toLowerCase()) : []
  if (data?.issuer?.type) {
    data.issuer.type = parseInt(data?.issuer?.type)
  }
  let isForeign = data?.currenciesSold === 'Foreign'
  let isMultiForeign = ['MultipleForeign', 'EGPAndForeign', 'TwoForeign', 'ThreeForeign'].includes(data?.currenciesSold)
  let currency = data?.currenciesSold === 'Foreign' && data?.currencySegments?.length === 1 ? data?.currencySegments[0]?.currency : 'EGP'
  let currencyRates = 1
  if (!data?.currenciesSold) {
    let allCurrencies = data?.invoiceLines?.map(item => item?.unitValue?.currencySold)
    currencyRates = data?.invoiceLines?.map(item => item?.unitValue?.currencyExchangeRate)?.shift()
    if (allCurrencies?.every(v => v === allCurrencies[0])) {
      isForeign = allCurrencies[0] !== 'EGP'
      currency = allCurrencies[0]
    } else {
      isMultiForeign = true
    }
  }

  return {
    general: {
      submissionUUID: data?.submissionUUID || '',
      documentTypeVersion: data?.documentTypeVersion || '',
      documentType: data?.documentType || '',
      documentTypeName: (locale === 'ar') ? data?.documentTypeNameSecondaryLang || data?.documentTypeNamePrimaryLang || '' : data?.documentTypeNamePrimaryLang || ''
    },
    printableData: {
      uuid: data?.uuid || '',
      MSuuid: data?.MSuuid || '',
      SPuuid: data?.SPuuid || '',
      internalID: data?.internalID || '',
      dateTimeIssued: data?.dateTimeIssued || '',
      dateTimeRecevied: data?.dateTimeRecevied || '',
      serviceDeliveryDate:data?.serviceDeliveryDate || '',
      cancelRequestDate: data?.cancelRequestDate || '',
      cancelRequestDelayedDate: data?.cancelRequestDelayedDate || '',
      declineCancelRequestDate: data?.declineCancelRequestDate || '',
      rejectRequestDate: data?.rejectRequestDate || '',
      rejectRequestDelayedDate: data?.rejectRequestDelayedDate || '',
      declineRejectRequestDate: data?.declineRejectRequestDate || '',
      references: data?.references?.length ? data?.references : null
    },
    status: {
      uuid: data?.uuid || '',
      msUUID: data?.MSuuid || '',
      publicUrl: data?.publicUrl || '',
      status: data?.status || '',
      MSStatus: data?.MSStatus || '',
      statusName: !!statusArr?.length ? statusArr[0][`name_${locale}`] : (data?.status || ''),
      msStatusName: !!msStatusArr?.length ? msStatusArr[0][`name_${locale}`] : (data?.MSStatus || ''),

      documentStatusReason: data?.documentStatusReason || '',
      cancelRequestDate: data?.cancelRequestDate || '',
      cancelRequestDelayedDate: data?.cancelRequestDelayedDate || '',
      declineCancelRequestDate: data?.declineCancelRequestDate || '',
      canbeCancelledUntil: data?.canbeCancelledUntil || '',

      rejectRequestDate: data?.rejectRequestDate || '',
      rejectRequestDelayedDate: data?.rejectRequestDelayedDate || '',
      declineRejectRequestDate: data?.declineRejectRequestDate || '',
      canbeRejectedUntil: data?.canbeRejectedUntil || ''
    },
    validation: getInvoiceValidation(data?.validationResults?.validationSteps || [], locale),
    issuer: {
      ...data?.issuer,
      taxpayerActivityCode: data?.taxpayerActivityCode,
      addressObj: data?.issuer?.address
    } || {},
    receiver: { ...data?.receiver, addressObj: data?.receiver?.address } || {},
    invoiceItems: {
      invoiceItems: getInvoiceItems(data?.invoiceLines || [], locale),
      invoiceItemsSums: {
        totalSales: (!data?.currenciesSold && !!isForeign) ? parseFloat(data?.totalSales || 0) / parseFloat(currencyRates || 1) : data?.currencySegments?.length ? data?.currencySegments[0]?.totalSales || data?.totalSales || '' : data?.totalSales || '',
        netAmount: (!data?.currenciesSold && !!isForeign) ? parseFloat(data?.netAmount || 0) / parseFloat(currencyRates || 1) : data?.currencySegments?.length ? data?.currencySegments[0]?.netAmount || data?.netAmount || '' : data?.netAmount || '',
        totalItemsDiscountAmount: (!data?.currenciesSold && !!isForeign) ? parseFloat(data?.totalItemsDiscountAmount || 0) / parseFloat(currencyRates || 1) : data?.currencySegments?.length ? data?.currencySegments[0]?.totalItemsDiscountAmount || data?.totalItemsDiscountAmount || '' : data?.totalItemsDiscountAmount || '',
        taxTotals: data?.currencySegments?.length ? data?.currencySegments[0]?.taxTotals || data?.taxTotals || [] : data?.taxTotals || [],
        totalDiscount: (!data?.currenciesSold && !!isForeign) ? parseFloat(data?.totalDiscount || 0) / parseFloat(currencyRates || 1) : data?.currencySegments?.length ? data?.currencySegments[0]?.totalDiscount || data?.totalDiscount || '' : data?.totalDiscount || '',
        extraDiscountAmount: (!data?.currenciesSold && !!isForeign) ? parseFloat(data?.extraDiscountAmount || 0) / parseFloat(currencyRates || 1) : data?.currencySegments?.length ? data?.currencySegments[0]?.extraDiscountAmount || data?.extraDiscountAmount || '' : data?.extraDiscountAmount || '',
        totalAmount: (!data?.currenciesSold && !!isForeign) ? parseFloat(data?.totalAmount || 0) / parseFloat(currencyRates || 1) : data?.currencySegments?.length ? data?.currencySegments[0]?.totalAmount || data?.totalAmount || '' : data?.totalAmount || '',
        invoiceItemsSumsEGP: {
          totalSales: data?.totalSales || '',
          netAmount: data?.netAmount || '',
          totalItemsDiscountAmount: data?.totalItemsDiscountAmount || '',
          taxTotals: data?.taxTotals || [],
          totalDiscount: data?.totalDiscount || '',
          extraDiscountAmount: data?.extraDiscountAmount || '',
          totalAmount: data?.totalAmount || ''
        }
      }
    },
    isForeign: isForeign,
    isMultiForeign: isMultiForeign,
    currency: currency || 'EGP',
    freeze: !!data?.freezeStatus?.frozen? data?.freezeStatus : null,
    payment: data?.payment || {},
    order: {
      purchaseOrderReference: data?.purchaseOrderReference || '',
      purchaseOrderDescription: data?.purchaseOrderDescription || '',
      salesOrderReference: data?.salesOrderReference || '',
      salesOrderDescription: data?.salesOrderDescription || '',
      proformaInvoiceNumber: data?.proformaInvoiceNumber || ''
    },
    delivery: data?.delivery || {},
    signatures: { signatures: data?.signatures || [] }
  }
}

const getInvoiceValidation = (data, locale) => {
  let validations = []
  if (!!data?.length) {
    data?.forEach(singleValidation => {
      if (singleValidation?.status === 'Invalid') {
        let validation = {
          title: singleValidation?.stepName || '',
          subTitle: (locale === 'ar') ? singleValidation?.error?.errorAr || singleValidation?.error?.error || '' : singleValidation?.error?.error || '',
          list: []
        }
        if (!!singleValidation?.error?.innerError?.length) {
          singleValidation?.error?.innerError?.forEach(error => {
            validation.list.push({
              code: error?.errorCode || '',
              name: (locale === 'ar') ? error?.errorAr || error?.error || '' : error?.error || ''
            })
          })
        }
        validations.push(validation)
      }
    })
  }
  return validations
}
const getInvoiceItems = (data, locale) => {
  let items = []
  if (!!data?.length) {
    data?.forEach(singleItem => {
      let item = {
        itemName: (locale === 'ar') ? singleItem?.itemSecondaryName || singleItem?.itemPrimaryName || singleItem?.itemName || '' : singleItem?.itemPrimaryName || singleItem?.itemName || '',
        description: (locale === 'ar') ? singleItem?.itemSecondaryDescription || singleItem?.itemPrimaryDescription || singleItem?.description || '' : singleItem?.itemPrimaryDescription || singleItem?.description || '',
        itemType: singleItem?.itemType || '',
        itemCode: singleItem?.itemCode || '',
        internalCode: singleItem?.internalCode || '',
        quantity: singleItem?.quantity || 0,
        unitType: singleItem?.unitType || '',
        unitCurrency: singleItem?.unitValue || '',
        unitAmount: singleItem?.unitValue?.amountEGP || 0,
        unitAmountForeign: singleItem?.unitValue?.amountSold || 0,
        weightUnitType: singleItem?.weightUnitType || '',
        weightQuantity:singleItem?.weightQuantity || '',
        salesTotal: singleItem?.salesTotal || 0,
        salesTotalForeign: (!singleItem?.salesTotalForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(singleItem?.salesTotal || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1) : singleItem?.salesTotalForeign || 0,
        discount: singleItem?.discount || {},
        discountForeign: singleItem?.discountForeign || {},
        totalTaxableFees: singleItem?.totalTaxableFees || 0,
        totalTaxableFeesForeign: (!singleItem?.totalTaxableFeesForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(singleItem?.totalTaxableFees || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1): singleItem?.totalTaxableFeesForeign || 0,
        totalTaxableItems: (singleItem?.lineTaxableItems || singleItem?.taxableItems)?.map(tax => parseFloat(tax?.amount || 0))?.reduce((sum, value) => {
          return sum + value
        }, 0) || 0,
        totalTaxableItemsForeign: (singleItem?.lineTaxableItems || singleItem?.taxableItems)?.map(tax => (!tax?.amountForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(tax?.amount || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1) : parseFloat(tax?.amountForeign || 0))?.reduce((sum, value) => {
          return sum + value
        }, 0) || 0,
        valueDifference: singleItem?.valueDifference || 0,
        valueDifferenceForeign: (!singleItem?.valueDifferenceForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(singleItem?.valueDifference || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1): singleItem?.valueDifferenceForeign || 0,
        netTotal: singleItem?.netTotal || 0,
        netTotalForeign: (!singleItem?.netTotalForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(singleItem?.netTotal || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1): singleItem?.netTotalForeign || 0,
        itemsDiscount: singleItem?.itemsDiscount || 0,
        itemsDiscountForeign: (!singleItem?.itemsDiscountForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(singleItem?.itemsDiscount || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1): singleItem?.itemsDiscountForeign || 0,
        total: singleItem?.total || 0,
        totalForeign: (!singleItem?.totalForeign && singleItem?.unitValue?.currencySold !== 'EGP') ? parseFloat(singleItem?.total || 0) / parseFloat(singleItem?.unitValue?.currencyExchangeRate || 1):  singleItem?.totalForeign || 0
      }
      items.push(item)
    })
  }
  return items
}